// apps/web/src/components/Co2OfferBridge.tsx

"use client"

import { ArrowRight } from "lucide-react"
import Link from "next/link"
import { Card, CardContent } from "@/components/ui/card"
import { ANALYTICS_EVENTS, track } from "@/lib/analytics"

interface Co2OfferBridgeProps {
  /** Where the bridge was rendered, e.g. "co2-detail" — recorded on the CTA event. */
  location: string
}

/**
 * Route from a CO₂ comparison page to what GIOF actually does.
 *
 * These pages take roughly half the site's traffic but previously linked only
 * to "/" and to each other. The visitor arrived for a number, not for a
 * service, so this states who built it rather than asking for anything.
 */
export function Co2OfferBridge({ location }: Co2OfferBridgeProps) {
  return (
    <Card className="max-w-6xl mx-auto bg-brand-1 border-2 border-brand-90 shadow-none rounded-none">
      <CardContent className="p-4 sm:p-6 lg:p-8 text-center">
        <h3 className="text-xl sm:text-2xl font-semibold text-brand-90 mb-4">Who built this?</h3>
        <p className="text-sm sm:text-base text-brand-60 mb-6">
          I'm Arnstein. I build content systems, websites, and the infrastructure around them — for
          teams and agencies who need something that actually works. This calculator is one small
          example of that.
        </p>
        <Link
          href="/"
          onClick={() => track(ANALYTICS_EVENTS.ctaClick, { location })}
          className="inline-flex items-center gap-2 text-brand-50 hover:text-[hsl(var(--giof-pink))] underline text-sm font-medium transition-colors"
        >
          See what I work on
          <ArrowRight className="h-4 w-4" />
        </Link>
      </CardContent>
    </Card>
  )
}
